import { render, staticRenderFns } from "./OrganizationNew.vue?vue&type=template&id=3cfc1c0b&scoped=true"
import script from "./OrganizationNew.vue?vue&type=script&lang=js"
export * from "./OrganizationNew.vue?vue&type=script&lang=js"
import style0 from "./OrganizationNew.vue?vue&type=style&index=0&id=3cfc1c0b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfc1c0b",
  null
  
)

export default component.exports